// export type { WebCamsPageProps } from "./web-cams-page";
export { WebCamsPage } from "./web-cams-page";
